import React, { createContext, useContext, useState } from 'react';

const ScrollContext = createContext(null);

export const ScrollProvider = ({ children }) => {
  const [scrollInstance, setScrollInstance] = useState(null);

  return (
    <ScrollContext.Provider value={{ scrollInstance, setScrollInstance }}>
      {children}
    </ScrollContext.Provider>
  );
};

export const useScroll = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error('useScroll must be used within a ScrollProvider');
  }
  return context;
};